import React from "react";

interface ZoomImageProps {
  src: string;
  alt: string;
  url: string;
}

const ZoomImage: React.FC<ZoomImageProps> = ({ src, alt, url }) => {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <div className="relative group overflow-hidden p-4 rounded-md">
        <img
          src={src}
          alt={alt}
          className="transition-all duration-30 ease-in-out transform group-hover:scale-110 hover:shadow-md hover:z-10 hover:shadow-slate-700 p-4 rounded-md"
          style={{
            width: "auto",
            height: "80px",
            transition: "transform 0.3s ease-in-out, drop-shadow 0.3s ease-in-out",
          }}
        />
      </div>
    </a>
  );
};

export default ZoomImage;
